import { render, staticRenderFns } from "./researchInsights.vue?vue&type=template&id=66e0e0b8&"
import script from "./researchInsights.vue?vue&type=script&lang=js&"
export * from "./researchInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports